module.exports = "<p>\n  managemodules works!\n</p>\n"